import store from '../store';

export const beginRequest = async () => {
    await store.dispatch('setSnackbarAction', false);
    await store.dispatch('setLoaderAction', { value: true });
}